module.exports = __webpack_public_path__ + "static/media/logo.cbeec151.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/images/logo.png
// module id = 2120
// module chunks = 0